// src/components/I18nProvider.tsx
'use client';

import { I18nextProvider } from 'react-i18next';
import { ensureI18n, type AvailableLangs } from '@/locales/index';

export default function I18nProvider({ lang, children }: { lang: AvailableLangs; children: React.ReactNode }) {
  const i18n = ensureI18n(lang);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
